import React from 'react'
import './style.css';

const FormSeperator = ({content}) => {
  return (
    <div className='form-seperator'>
      <div>{content}</div>
      <div className='form-seperator-line'></div>
    </div>
  )
}

export default FormSeperator
